import { Box } from '@mui/material'
import React, { ReactElement, useEffect, useRef, useState } from 'react'

type ReportElementChartWithLegendProps = {
  legend: ReactElement
  chart: ReactElement
  print?: boolean
}

const ReportElementChartWithLegend: React.FC<
  ReportElementChartWithLegendProps
> = ({ legend, chart, print = false }) => {
  const chartRef = useRef<HTMLElement>()
  const legendRef = useRef<HTMLElement>()
  const [height, setHeight] = useState(0)
  const [chartHeight, setChartHeight] = useState(0)
  const [legendHeight, setLegendHeight] = useState(0)
  useEffect(() => {
    if (chartRef.current && legendRef.current) {
      const chartObserver = new ResizeObserver((entries) =>
        setChartHeight(entries[0].contentRect.height)
      )
      const legendObserver = new ResizeObserver((entries) =>
        setLegendHeight(entries[0].contentRect.height)
      )
      chartObserver.observe(chartRef.current)
      legendObserver.observe(legendRef.current)
      return () => {
        chartRef.current && chartObserver.unobserve(chartRef.current)
        legendRef.current && legendObserver.unobserve(legendRef.current)
      }
    }
  }, [chartRef, legendRef])

  useEffect(() => {
    setHeight(chartHeight + legendHeight)
  }, [chartHeight, legendHeight])

  return (
    <Box py={4} px={print ? 0 : 4}>
      <Box sx={{ height: `${height}px` }}>
        <Box ref={chartRef}>{chart}</Box>
        <Box
          ref={legendRef}
          sx={{
            position: 'sticky',
            bottom: '0px',
            alignSelf: 'flex-start',
            zIndex: '100',
          }}
        >
          {legend}
        </Box>
      </Box>
    </Box>
  )
}

export default ReportElementChartWithLegend
